import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";

import { generalConfigStore } from "@store";

import { CompositeProductStepPreview } from "./CompositeProductStepPreview";
import { GenericInterfacePreview } from "./GenericInterfacePreview";
import { SummaryPreview } from "./SummaryPreview";
import CustomerBenefitPreview from "./CustomerBenefitPreview";

// Same literal as MainContent.tsx (external contract with the kiosk).
const DISPLAY_MODE_POPUP = "popup" as const;

export function OrderTakingPreview(): JSX.Element {
    const { t } = useTranslation();
    const {
        selectSubStepOrderTaking,
        project: { template },
    } = useSnapshot(generalConfigStore);

    const orderTakingPage = template.pages.ways[
        "orderTaking"
    ] as OrderTakingPageType;
    const isPopupMode =
        orderTakingPage?.compositeProduct?.displayMode === DISPLAY_MODE_POPUP;

    return (
        <div
            className="d-flex justify-content-center align-items-center p-1 m-2"
            style={{
                backgroundColor: "#363636",
                borderRadius: "10px",
                height: "740px",
                width: "448px",
            }}
        >
            <div
                style={{
                    backgroundColor: "#FFFFFF",
                    height: "725px",
                    width: "430px",
                    borderRadius: "10px",
                }}
            >
                <div
                    style={{
                        backgroundColor: "#FFFFFF",
                        height: "725px",
                        width: "430px",
                        borderRadius: "10px",
                        position: "relative",
                    }}
                >
                    {selectSubStepOrderTaking === t("Generic interface") ? (
                        <GenericInterfacePreview />
                    ) : selectSubStepOrderTaking ===
                      t("Composite product step") ? (
                        isPopupMode ? (
                            // Popup mode: generic interface fills the host,
                            // composite product step floats on top as a
                            // centered popup (white opaque card, rounded
                            // corners + shadow via the popup CSS class).
                            <>
                                <div
                                    style={{
                                        position: "absolute",
                                        inset: 0,
                                        zIndex: 1,
                                    }}
                                >
                                    <GenericInterfacePreview />
                                </div>
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        zIndex: 10,
                                    }}
                                >
                                    <CompositeProductStepPreview />
                                </div>
                            </>
                        ) : (
                            <CompositeProductStepPreview />
                        )
                    ) : selectSubStepOrderTaking === t("Summary") ? (
                        <SummaryPreview />
                    ) : selectSubStepOrderTaking === t("Customer benefit") ? (
                        <CustomerBenefitPreview />
                    ) : null}
                </div>
            </div>
        </div>
    );
}
